var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import React, { useContext } from 'react';
import { logEvent, MessageType } from '../../../../../util/EventLog';
import { BasePartner } from '../BasePartner';
import styles from './WellforcePartner.css';
import { SourceOfCare } from '../../../../clearstep/proto/results_pb';
import '../../../../clearstep/proto/care_locations_pb';
import CareLocation from '../../../../clearstep/CareLocation/CareLocation';
import SectionHeader from '../../../../clearstep/SectionHeader/SectionHeader';
import { THEME } from '../../../../clearstep/util/Theme';
import CareCard from '../../../CareCard/CareCard';
import { StethoscopeCircleIcon } from '../../../../svg/StethoscopeCircleIcon';
import { VirtualVisitCareOptionIcon } from '../../../../svg/VirtualVisitCareOptionIcon';
import { HomeCareOverviewIcon } from '../../../../svg/HomeCareOverviewIcon';
import ResultsCard from '../../../ResultsCard/ResultsCard';
import { SpecialistCareDetail } from '../../../../../util/care_details/SpecialistCareDetail';
import { isEligibilityResult, SpecialistCareDetailToDescription, } from '../CareDetails';
import { UserContext } from '../../../../../context/UserContext';
import { prepareText } from '../../../../clearstep/TextUtil';
import { buildCareCardFromPropsObject } from '../../../CareCard/CareCardBuilder';
import '../../../CareCard/ButtonContainer/ButtonContainer';
import '../../../../clearstep/Types';
/* eslint-disable react/jsx-no-literals */
/*
  disabling jsx-no-literals as partner doesn't currently require translation
*/
var specialistCustomizations = (_a = {},
    _a[SpecialistCareDetail.ALLERGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Allergy/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.ANESTHESIOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Anesthesiology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.AUDIOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Audiology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.BARIATRIC_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Weight-and-Wellness-Center/Surgical-Weight-Loss',
            },
        ],
    },
    _a[SpecialistCareDetail.CANCER_CENTER] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Cancer-Center/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.CARDIAC_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Cardiac-Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.CARDIOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Cardiology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.CARDIOVASCULAR_CENTER] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Cardiovascular-Center/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.CLINICAL_DECISION_MAKING] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Clinical-Decision-Making/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.COLORECTAL_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Colon-and-Rectal-Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.CONCIERGE_MEDICINE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pratt-Diagnostic-Center/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.CLINICAL_NUTRITION] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Nutrition/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.DENTISTRY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Dentistry',
            },
        ],
    },
    _a[SpecialistCareDetail.DEPARTMENT_OF_MEDICINE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Medicine/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.DEPARTMENT_OF_PEDIATRICS] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pediatrics',
            },
        ],
    },
    _a[SpecialistCareDetail.DEPARTMENT_OF_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.INTERNAL_MEDICINE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Primary-Care/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.PEDIATRICS] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://pediatrics.tuftsmedicalcenter.org/Patient-Care-Services/Departments-and-Services/General-Pediatrics-Practice/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.GENERAL_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/General-Surgery',
            },
        ],
    },
    _a[SpecialistCareDetail.DERMATOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Dermatology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.EMERGENCY_SERVICES] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Emergency-Services',
            },
        ],
    },
    _a[SpecialistCareDetail.ENT] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Ear-Nose-and-Throat-ENT-Otolaryngology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.ENDOCRINOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Endocrinology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.GAMMA_KNIFE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Neurosurgery/Clinical-Care-Services/Gamma-Knife-Center',
            },
        ],
    },
    _a[SpecialistCareDetail.GASTROENTEROLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Gastroenterology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.GENETICS] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Genetics-and-Metabolism/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.INFECTIOUS_DISEASE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Infectious-Disease/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.GERIATRICS] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Geriatrics/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.HEMATOLOGY_ONCOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Hematology-Oncology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.HYPERBARIC_MEDICINE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Vascular-Surgery/Clinical-Care-Services/Vascular-Wound-and-Hyperbaric-Center',
            },
        ],
    },
    _a[SpecialistCareDetail.OBGYN] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Obstetrics-and-Gynecology/Clinical-Care-Services/Maternity-Services',
            },
        ],
    },
    _a[SpecialistCareDetail.NEPHROLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Nephrology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.NEUROLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Neurology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.NEUROSURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Neurosurgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.OCCUPATIONAL_THERAPY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Occupational-Therapy',
            },
        ],
    },
    _a[SpecialistCareDetail.GENERAL_ORTHOPEDIC] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Orthopaedics/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.ORTHOTICS_PROSTHETICS] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Orthotics-and-Prosthetics',
            },
        ],
    },
    _a[SpecialistCareDetail.PAIN_MANAGEMENT] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Anesthesiology/Clinical-Care-Services/Pain-Management-Program',
            },
        ],
    },
    _a[SpecialistCareDetail.PALLIATIVE_CARE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Palliative-Care-Services',
            },
        ],
    },
    _a[SpecialistCareDetail.PATHOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pathology-and-Lab-Medicine/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.PEDIATRICS] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pediatrics',
            },
        ],
    },
    _a[SpecialistCareDetail.PELVIC_FLOOR] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pelvic-Floor-Program',
            },
        ],
    },
    _a[SpecialistCareDetail.PHARMACY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pharmacy',
            },
        ],
    },
    _a[SpecialistCareDetail.PHYSICAL_MEDICINE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Physical-Medicine/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.PHYSICAL_THERAPY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Physical-Therapy',
            },
        ],
    },
    _a[SpecialistCareDetail.PLASTIC_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Plastic-Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.RADIOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Radiology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.PSYCHIATRY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Psychiatry/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.PULMONOLOGIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Pulmonary/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.RADIATION_ONCOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Radiation-Oncology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.RHEUMATOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Rheumatology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.SPEECH_THERAPY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Speech-Language-Pathology/Speech-Language-Services',
            },
        ],
    },
    _a[SpecialistCareDetail.SPINE_CENTER] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Spine-Center',
            },
        ],
    },
    _a[SpecialistCareDetail.ACUTE_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Surgical-Critical-Care',
            },
        ],
    },
    _a[SpecialistCareDetail.SURGICAL_ONCOLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Surgical-Oncology',
            },
        ],
    },
    _a[SpecialistCareDetail.THORACIC_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Thoracic-Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.TRANSPLANT_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Transplant-Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.TRAUMA_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Trauma-Surgery',
            },
        ],
    },
    _a[SpecialistCareDetail.UROLOGY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Urology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.VASCULAR_SURGERY] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Vascular-Surgery/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.VOLUNTEER_SERVICES] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Patient-and-Family-Services/Volunteer-Services.aspx',
            },
        ],
    },
    _a[SpecialistCareDetail.WEIGHT_WELLNESS] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Weight-and-Wellness-Center/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.WOUND_CARE] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/departments-and-services/vascular-surgery/clinical-care-services/vascular-wound-and-hyperbaric-center',
            },
        ],
    },
    _a[SpecialistCareDetail.IMAGING_TEST] = {
        description: 'You can come to the Radiology Department for a variety of imaging services, from the basic to the most complex.',
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Radiology/Overview',
            },
        ],
    },
    _a[SpecialistCareDetail.OBGYN] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Obstetrics-and-Gynecology/Doctors-Care-Team',
            },
        ],
    },
    _a[SpecialistCareDetail.OPHTHALMOLOGIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Ophthalmology/Doctors-Care-Team',
            },
        ],
    },
    _a[SpecialistCareDetail.KNEE_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Orthopaedics/Doctors-Care-Team',
            },
        ],
    },
    _a[SpecialistCareDetail.UROLOGIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/departments-and-services/urology/doctors-care-team',
            },
        ],
    },
    _a[SpecialistCareDetail.ENT] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Ear-Nose-and-Throat-ENT-Otolaryngology/Doctors-Care-Team',
            },
        ],
    },
    _a[SpecialistCareDetail.SHOULDER_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Orthopaedics/Doctors-Care-Team',
            },
        ],
    },
    _a[SpecialistCareDetail.HAND_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Orthopaedics/Doctors-Care-Team',
            },
        ],
    },
    _a[SpecialistCareDetail.FOOT_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Orthopaedics/Doctors-Care-Team',
            },
        ],
    },
    _a[SpecialistCareDetail.SPINE_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/departments-and-services/spine-center',
            },
        ],
    },
    _a[SpecialistCareDetail.FOREARM_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Orthopaedics/Doctors-Care-Team',
            },
        ],
    },
    _a[SpecialistCareDetail.HIP_SPECIALIST] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Orthopaedics/Doctors-Care-Team',
            },
        ],
    },
    _a[SpecialistCareDetail.GENERAL_ORTHOPEDIC] = {
        buttons: [
            {
                cta: 'Get More Info',
                url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Orthopaedics/Doctors-Care-Team',
            },
        ],
    },
    _a);
var WellforcePartner = /** @class */ (function (_super) {
    __extends(WellforcePartner, _super);
    function WellforcePartner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.behavioralHealthOption = function () { return (React.createElement(CareCard, { buttons: [
                {
                    cta: 'Find more information',
                    url: 'https://www.tuftsmedicalcenter.org/patient-care-services/Departments-and-Services/Psychiatry/Overview',
                    lookerTags: {
                        behavioralHealth: '1',
                    },
                },
            ], description: "You rely on Tufts Medical Center for optimal healthcare, and your mental health deserves exceptional treatment and attention, too. The Department of Psychiatry at Tufts Medical Center is one of the longest-running and most diversified psychiatric services at a general hospital in Boston.", noMargin: true })); };
        return _this;
    }
    WellforcePartner.prototype.haveCareLocations = function (options) {
        var careLocations = options.careLocations, careType = options.careType;
        if (careType === SourceOfCare.Type.DENTIST) {
            return Array.isArray(careLocations) && !!careLocations.length;
        }
        return true;
    };
    WellforcePartner.prototype.careOptionDescription = function (options) {
        var careType = options.careType;
        return careType === SourceOfCare.Type.URGENT_CARE ? (React.createElement("div", { className: styles.wellforce__resourceHeader },
            React.createElement("p", null, "Urgent care is for non-life threatening conditions and other ailments that require prompt medical attention. Our Wellforce primary care physicians are equipped to handle urgent care conditions, in addition to Circle Health physicians, experienced in emergency and family medicine. You choose from either option below."))) : null;
    };
    WellforcePartner.prototype.wellforceCta = function (options) {
        var cta = options.cta, url = options.url, description = options.description;
        return (React.createElement(CareCard, { description: description, buttons: [
                {
                    cta: cta,
                    url: url,
                },
            ] }));
    };
    WellforcePartner.prototype.wellforcePrimaryCare = function (text, url, careLocation) {
        var description = 'Please complete our appointment request form to request an appointment with a provider.';
        return (React.createElement("div", { className: styles.wellforce__practiceLocation },
            React.createElement(CareLocation, { location: careLocation, hideFindOtherLocations: true }),
            this.wellforceCta({ cta: text, url: url, description: description })));
    };
    WellforcePartner.prototype.wellforceUrgentCare = function (text, url, careLocation) {
        var description = 'Please complete our appointment request form to request an appointment with a provider.';
        return (React.createElement("div", { className: styles.wellforce__resourceSection },
            React.createElement("div", null,
                React.createElement(CareLocation, { location: careLocation, hideMap: true }),
                React.createElement("div", { className: styles.wellforce__resourceButton }, this.wellforceCta({ cta: text, url: url, description: description }))),
            this.wellforceCircleHealth()));
    };
    WellforcePartner.prototype.wellforceCircleHealth = function () {
        var ctaText = 'Find a Circle Health urgent care';
        var circleUrl = 'https://www.circle-health.org/care-and-services/urgent-care';
        var description = 'Please complete our appointment request form to request an appointment with a provider.';
        return (React.createElement("div", { className: styles.wellforce__image },
            React.createElement("div", null,
                React.createElement("a", { href: circleUrl, onClick: function () {
                        return logEvent(MessageType.CLICKED_PARTNER_CARE_OPTION, { name: 'Circle Health logo' }, { partner: THEME.partner });
                    }, target: "_blank", rel: "noreferrer" },
                    React.createElement("img", { src: "/static/images/partners/wellforce/circle_health_logo.png", alt: "Circle Health logo" })),
                React.createElement("div", { className: styles.wellforce__resourceButton }, this.wellforceCta({ cta: ctaText, url: circleUrl, description: description })))));
    };
    WellforcePartner.prototype.wellforceAdditionalGuidanceOption = function (text, url, careLocation) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.wellforce__description },
                React.createElement(SectionHeader, { text: "Want additional guidance?" }),
                React.createElement("p", null, "Based on what you told us, it sounds like you're having an emergency and should seek emergency care now. If you believe you are having a medical emergency, please call 911. However, if you think the situation is different and would like further guidance, contact your primary care doctor now.")),
            this.wellforcePrimaryCare(text, url, careLocation)));
    };
    WellforcePartner.prototype.wellforceHomeCareProviderOption = function (text, url, careLocation) {
        return (React.createElement(React.Fragment, null,
            React.createElement("header", null,
                React.createElement("h1", null, "Still want to talk to a healthcare provider?")),
            React.createElement("main", { className: styles.wellforce__practiceLocation },
                React.createElement(CareLocation, { location: careLocation, hideFindOtherLocations: true }),
                this.wellforceCta({ cta: text, url: url }))));
    };
    WellforcePartner.prototype.wellforceCovidRelatedEmergencyResponse = function () {
        var cta = 'Lowell General Hospital emergency services';
        var url = 'https://www.lowellgeneral.org/care-and-services/emergency-department';
        return (React.createElement(CareCard, { title: "Get care now", icon: React.createElement(StethoscopeCircleIcon, null), buttons: [
                {
                    cta: cta,
                    url: url,
                },
            ] }));
    };
    WellforcePartner.prototype.showZipcodeInput = function (careOptions) {
        if (careOptions.length === 1) {
            var _a = careOptions[0], careType = _a.careType, careDetails = _a.careDetails;
            return !isEligibilityResult(careType, careDetails);
        }
        return true;
    };
    WellforcePartner.prototype.addScheduleAppointmentLink = function (careCard) {
        var newButtons = [
            {
                cta: 'Schedule Appointment',
                url: 'https://www.tuftsmedicalcenter.org/RequestAppointment',
            },
        ];
        var buttons = careCard.buttons;
        if (careCard) {
            if (buttons) {
                var hasScheduleAppointment = buttons.some(function (button) { return button.cta === 'Schedule Appointment'; });
                if (hasScheduleAppointment) {
                    return buttons;
                }
                return newButtons.concat(buttons);
            }
        }
        return newButtons;
    };
    WellforcePartner.prototype.partnerOptionWithCareDetail = function (options) {
        var _a, _b;
        var isProxyUser = useContext(UserContext).isProxyUser;
        // Remove eligibility tag from details. If exists, mark isEligibility so a disclaimer is not added
        if (!options.careDetails) {
            return null;
        }
        var partnerCareDetails = options.careDetails.map(function (detail) {
            var detailArray = detail.split('_');
            return detailArray[0];
        });
        var firstDetail = partnerCareDetails.find(function (detail) { return detail in specialistCustomizations; });
        if (!firstDetail) {
            return null;
        }
        var mapDescription = (_a = SpecialistCareDetailToDescription[firstDetail]) !== null && _a !== void 0 ? _a : '';
        var card = specialistCustomizations[firstDetail];
        card.buttons = this.addScheduleAppointmentLink(card);
        var cardDescription = card.description;
        var specialistDescription = (_b = SpecialistCareDetailToDescription[firstDetail]) !== null && _b !== void 0 ? _b : prepareText("".concat(mapDescription, " You may need a referral from your primary care provider depending on your insurance. Click \u201CSchedule Appointment\u201D below to find out."), { isProxyUser: isProxyUser });
        var description = cardDescription !== null && cardDescription !== void 0 ? cardDescription : specialistDescription; // Override standard mapping with per partner description if exists
        return buildCareCardFromPropsObject(__assign(__assign({}, card), { headerClasses: [], title: '', description: description, descriptionClasses: ['p-0'] }));
    };
    WellforcePartner.prototype.wellforceCovidDoctorTriageResponse = function (options) {
        var wellforceDescription = 'Please complete our appointment request form to request an appointment with a provider.';
        var cdcCta = 'CDC COVID-19 vaccine information';
        var cdcURL = 'https://www.cdc.gov/coronavirus/2019-ncov/vaccines/index.html';
        var massCta = 'Massachusetts plan for COVID-19 vaccinations';
        var massURL = 'https://www.mass.gov/info-details/when-can-i-get-the-covid-19-vaccine';
        var cta = options.cta, url = options.url, partnerName = options.partnerName;
        return (React.createElement(ResultsCard, null,
            React.createElement("h1", null, "Find care near you"),
            React.createElement(React.Fragment, null,
                this.wellforceCta({ cta: cta, url: url, description: wellforceDescription }),
                React.createElement(CareCard, { title: "Speak with a doctor now", icon: React.createElement(VirtualVisitCareOptionIcon, null), description: "If you'd still like to schedule a virtual visit with a ".concat(partnerName, " provider, please complete our appointment request form to schedule a virtual visit with a provider."), buttons: [
                        {
                            cta: 'Schedule a virtual visit',
                            url: url,
                        },
                    ] }),
                React.createElement(CareCard, { title: "More information", icon: React.createElement(HomeCareOverviewIcon, null), buttons: [
                        {
                            cta: cdcCta,
                            url: cdcURL,
                        },
                        {
                            cta: massCta,
                            url: massURL,
                        },
                    ] }))));
    };
    return WellforcePartner;
}(BasePartner));
export { WellforcePartner };
